module.exports = __webpack_public_path__ + "img/home-left-brush.e23f2a31.png";